import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import keymaster from 'keymaster';
import moment from 'moment';
import time from '../utils/time';
import { Modal } from 'react-bootstrap';

import AutoProjectInput from './AutoProjectInput';
import AutoTaskInput from './AutoTaskInput';
import DatePicker from 'react-datepicker';
import DurationFormatter from '../utils/duration';
import * as entityUtils from '../utils/entityUtils';
import SimpleHashtagEditor from './SimpleHashtagEditor';

import * as logEntryActions from '../actions/logEntryActionCreators';
import userTaskActions from '../actions/userTaskActionCreators';
import floatingTaskActions from '../actions/floatingTaskActionCreators';

require.ensure([], () => {
    require('./NewLogEntryWidget.less');
    require('./Material-Design-Iconic.less');
});

let taggyIcon = require('../../img/taggy_icon.png');

const className = "NewLogEntryWidget";

class NewLogEntryWidget extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            name: "",
            description: "",
            startTime: "",
            overtime: false,
            tasks: this.props.tasks,
            date: this.props.date,
            durationString: "",
            duration: 0,
            projects: this.props.projects
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {

        if (this.props.fillTaskForLogEntry) {
            ReactDOM.findDOMNode(this.refs.durationInput).focus();

            //TODO see if needed
            /*
            if (this.props.user.username === this.props.currentUser.username) {
                this.props.dispatch(userTaskActions.loadById(entityUtils.getIDFromLink(this.props.fillTaskForLogEntry.userTaskID)));
            }
            this.setState({
                userQuota: this.props.fillTaskForLogEntry.userQuota
            });
            */
        }

        this.setUpBinds();
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            tasks: nextProps.tasksByUser,
            projects: nextProps.projectsByUser
        });
    }

    componentWillUnmount = () => { this.returnKeymaster(); }

    // EVENT HANDLERS

    handleCancel = () => {
        this.returnKeymaster();
        this.props.onRequestHide();
    }

    handleDescriptionChange = (description) => {
        this.setState({
            description: description
        });
    }

    handleDurationChange = (event) => {
        this.setState({
            durationString: event.target.value
        });
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter" && !keyEvent.shiftKey) {
            keyEvent.preventDefault();

            let hm = time.parseDuration(this.state.durationString.trim());

            this.setState({
                duration: hm !== null ? hm[2] : 0,
                durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : ""
            }, this.handleSave);
        }

        keyEvent.stopPropagation();
    }

    handleKeyUp = (keyEvent) => {
        if (keyEvent.key === "Escape") this.handleCancel();

        keyEvent.stopPropagation();
    }

    handleOvertimeChange = () => {
        this.setState({
            overtime: !this.state.overtime
        });
    }

    handleRefocus = () => {
        ReactDOM.findDOMNode(this.refs.taskInput.refs.taskField).focus();
    }

    handleRequestHide = () => {
        // noop
    }

    handleSave = () => {
        let taskID = this.props.selectedTask.id,
            duration = this.state.duration,
            startTime = this.state.startTime;

        let errors = [];

        if (taskID === null)
           errors.push({ input: "task", message: "A task must be selected" });

        if (isNaN(duration))
            duration = 0;

        if (duration > 1440)
            errors.push({ input: "duration", message: "Duration cannot exceed 24 hours" });

        if (duration < 0)
            errors.push({ input: "duration", message: "Duration cannot be negative" });

        if (startTime && startTime.length > 0) {
            let startTimeValidation = new RegExp(/^([0-9]?|1[0-9]|2[0-3]|0[0-9]):[0-5][0-9]$/);

            if (!startTimeValidation.test(startTime))
                errors.push({ input: "startTime", message: "Start time must be in HH:mm format" });
        }

        this.setState({ errors: errors });

        if (errors.length > 0) return;

        if (startTime && startTime.charAt(1) === ":") startTime = "0" + startTime;


        let logEntry = {
            taskID: taskID,
            taskName: this.props.selectedTask.name,
            color: this.props.selectedTask.color,
            date: this.state.date.format("YYYY-MM-DD"),
            alias: this.props.selectedTask.alias,
            projectName: this.props.selectedTask.projectName,
            duration: duration,
            startTime: startTime,
            description: this.state.description,
            overtime: this.state.overtime,
            status: "DRAFT",
            lastModifiedAt: moment().format("YYYY-MM-DD[T]H:mm:ss"),
            lastModifiedByUser: this.props.currentUser.givenName + " " + this.props.currentUser.surname + " (" + this.props.currentUser.username + ")",
            userID: this.props.pmo ? this.props.user.id : this.props.currentUser.id
        };

        this.createLogEntry(logEntry);
        this.returnKeymaster();
        this.props.onRequestHide();
    }

    handleSliderChange = (event) => {
        let hm = time.parseDuration(event.target.value.trim() + "min");

        this.setState({
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : ""
        });
    }

    handleStartTimeChange = (event) => {
        this.setState({
            startTime: event.target.value
        });
    }

    incrementDate = () => {
        this.state.date.add(1, 'day');

        this.setState({
            date: this.state.date
        });
    }

    decrementDate = () => {
        this.state.date.subtract(1, 'day');

        this.setState({
            date: this.state.date
        });
    }

    // OTHER METHODS

    _convertToStandardForm = (event) => {
        let hm = time.parseDuration(event.target.value.trim());

        this.setState({
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : "",
            elementFocused: false
        });
    }

    _convertStartTime = (event) => {
        let hm = time.parseStartTime(event.target.value.trim());

        this.setState({
            startTime: hm !== null ? time.startTimeFormat(hm[0], hm[1]) : ""
        });
    }

    _fieldHasError = (fieldName) => {
        if (!this.state.errors) return false;

        for (let i = 0; i < this.state.errors.length; i++)
            if (this.state.errors[i].input === fieldName) return true;

        return false;
    }

    createLogEntry = (logEntry) => {
        if (this.props.createLogEntry) {
            this.props.createLogEntry(logEntry);
        } else if (this.props.pmo) {
            this.props.dispatch(logEntryActions.pmoCreate(logEntry));
        } else {
            this.props.dispatch(logEntryActions.create(logEntry));
        }

        //so you can't delete the floating task if you just created a log entry for
        if (!logEntry.projectName) {
            setTimeout(() => {this.props.dispatch(floatingTaskActions.isDeletable(logEntry.taskID));}, 500);
        }
    }

    returnKeymaster = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
        this.props.returnKeymaster();
    }

    setUpBinds = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
        keymaster('left', this.decrementDate);
        keymaster('right', this.incrementDate);
    }

    disableBinds = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
    }

    // RENDER METHOD

    render = () => {
        let tasks = this.state.tasks;
        let dayClass = moment().format("DD-MM-YYYY") === this.state.date.format("DD-MM-YYYY") ? "label-day today" : "label-day";

        return (
            <Modal show={true} onKeyPress={this.handleKeyPress} onKeyUp={this.handleKeyUp} className="modal fade" id="myModal2" tabIndex="-1" role="dialog" aria-labelledby="myModal2Label" aria-hidden="true">
            <div className="modal-dialog new-log-entry">
                <div className="modal-content">
                    <div className="modal-header">
                        <button style={{marginTop : "-20px", marginRight : "-5px"}} onClick={this.handleCancel} type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                        <h4 className="modal-title" id="myModalLabel">New Log Record</h4>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="panel-log-date" >
                                <div className="row">
                                    <div className="col-lg-12">
                                        <i onClick={this.decrementDate} className="md-chevron-left md-lg"/>
                                        <span className={dayClass}><i className="md-today"/> &nbsp;<span>{this.state.date ? this.state.date.format('ddd') + " " + this.state.date.format("YYYY-MM-DD") : null}</span></span>
                                        <i onClick={this.incrementDate} className="md-chevron-right md-lg"/>
                                    </div>
                                </div>
                            </div>
                            <div>
                            <AutoProjectInput
                                enableClear
                                filterByDate={this.props.noFilter ? null : this.state.date}
                                hideArchived
                                keepAfterClick
                                projects={this.props.projects}
                                placeholder="Project name"
                                ref="projectInput"
                                topOffset="80px"
                                />

                            </div>
                            <div className={this._fieldHasError("task") ? "has-error" : ""}>
                            <AutoTaskInput
                                autoFocus={!this.props.fillTaskForLogEntry}
                                enableClear
                                filterByDate={this.props.noFilter ? null : this.state.date}
                                fillTaskForLogEntry={this.props.fillTaskForLogEntry}
                                forceInitialPopup={false}
                                hideClosed
                                placeholder="Task name"
                                isPmo={this.props.isPmo}
                                ref="taskInput"
                                tasks={this.props.tasks}
                                topOffset="128px"
                                />
                            </div>
                            {this.props.user.username === this.props.currentUser.username &&
                             this.state.userQuota && this.state.userQuota !== 0
                                ? <div className="text-center">
                                    <p>Quota on task: { DurationFormatter.format(this.state.userQuota)} - Used:
                                    {this.props.infoUserTask
                                        ? " " + DurationFormatter.format(this.props.infoUserTask.regularTimeSpent)
                                        + " + " + DurationFormatter.format(this.props.infoUserTask.overtimeTimeSpent) + " overtime"
                                        : " 0h + 0h overtime"
                                    }</p>
                                  </div>
                                : null
                            }

                            <div className="row">
                                <div className={!this.state.durationString && this.state.startTime ? "col-sm-7 has-error" : "col-sm-7"}>
                                    <input ref="durationInput" type="text" className="form-control" value={this.state.durationString} onChange={this.handleDurationChange} onBlur={this._convertToStandardForm} placeholder="Duration"/>
                                </div>
                                <div className="col-sm-5">
                                    <div className="checkbox">
                                        <label>
                                            <input type="checkbox" checked={this.state.overtime} onChange={this.handleOvertimeChange}/> Overtime
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className={this._fieldHasError("duration") ? "col-sm-12 has-error" : "col-sm-12"}>
                                    <input id="slider1" type="range" min="0" max="480" value={this.state.duration} step="30" placeholder="Duration" onChange={this.handleSliderChange}/><br/>
                                </div>
                            </div>
                            <div className="row">
                                <div className={this._fieldHasError("startTime") ?  "col-sm-7 has-error" : "col-sm-7"}>
                                    <input type="text" className="form-control" value={this.state.startTime} onBlur={this._convertStartTime} onChange={this.handleStartTimeChange} placeholder="Start Time"/>
                                </div>
                            </div>
                            <div>
                                <span style={{"position" : "relative", "top" : "40px", "left" : "330px"}}>
                                    <img src={taggyIcon} title="Adding a hashtag of the technologies used to the description of a log entry shows it on your profile description and the project on taggy"/>
                                </span>
                                <SimpleHashtagEditor value={this.state.description} maxLength="1024" disableBinds={this.disableBinds} setUpBinds={this.setUpBinds} onChange={this.handleDescriptionChange} save={this.handleSave}/>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" onClick={this.handleSave} className="btn btn-default btn-large">Create</button>
                        <button type="button" onBlur={this.handleRefocus} onClick={this.handleCancel} className="btn btn-default btn-discrete" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </Modal>
        );
    }
}

NewLogEntryWidget.propTypes = {
    createLogEntry: PropTypes.func,
    currentUser: PropTypes.object,
    date: PropTypes.object,
    dispatch: PropTypes.func,
    fillTaskForLogEntry: PropTypes.object,
    id: PropTypes.number,
    infoUserTask: PropTypes.object,
    isPmo: PropTypes.bool,
    noFilter: PropTypes.bool,
    onRequestHide: PropTypes.func,
    pmo: PropTypes.bool,
    projectsByUser: PropTypes.array,
    returnKeymaster: PropTypes.func,
    selectedTask: PropTypes.object,
    selectedProject: PropTypes.object,
    tasks: PropTypes.array,
    tasksByUser: PropTypes.array,
    user: PropTypes.object,
};

const mapStateToProps = (state) => {
    let projects = null;
    let currentView = state.projects.currentView;
    if(currentView === "EDIT_LOGS") {
        projects = state.projects.projectsByUser
    } else if (currentView === "LOG_OVERVIEW") {
        projects = state.projects.projects;
    }
    return {
        currentUser: state.users.currentUser,
        projects,
        projectsByUser: state.projects.projectsByUser,
        selectedTask: state.tasks.selectedTask,
        selectedProject: state.projects.selectedProject,
        tasksByUser: state.projects.tasksByUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewLogEntryWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/NewLogEntryWidget.js
 **/